export default "__VITE_PUBLIC_ASSET__8fc31f40__"